import { FormattedSeries } from '../types';

export const modifySeriesData = (
  seriesData: any[],
): any[] => seriesData.map((item) => {
  if (item.name === 'Max Temperature' || item.name === 'Min Temperature') {
    return {
      ...item,
      type: 'spline',
      marker: {
        enabled: true,
        radius: 4,
      },
      color: item.name === 'Max Temperature' ? '#FF0000' : '#0000FF',
      lineWidth: 2,
      yAxis: 0,
    };
  }
  if (item.name?.includes('Humidity')) {
    return {
      ...item,
      yAxis: 1,
      color: '#30b9f2',
    };
  }
  if (item.name?.includes('Temperature')) {
    return {
      ...item,
      yAxis: 0,
    };
  }
  return item;
});

export const calculateDailyExtremeTemperature = (
  temperatureData: FormattedSeries[],
  type: 'max' | 'min',
): FormattedSeries => {
  const dailyData: Record<string, { value: number; dateTime: string }[]> = {};
  temperatureData.forEach((series) => {
    if (series.sensorType === 'Temperature') {
      series.data.forEach((reading) => {
        const date = reading.dateTime.split(' ')[0];

        if (!dailyData[date]) {
          dailyData[date] = [];
        }

        dailyData[date].push({
          value: reading.value,
          dateTime: reading.dateTime,
        });
      });
    }
  });

  const extremeDailyData = Object.entries(dailyData).map(([, readings]) => {
    const extremeReading = readings.reduce((extreme, current) => {
      if (type === 'max') {
        return current.value > extreme.value ? current : extreme;
      }
      return current.value < extreme.value ? current : extreme;
    }, readings[0]);

    return {
      dateTime: extremeReading.dateTime,
      value: extremeReading.value,
    };
  });

  return {
    name: `${type === 'max' ? 'Max' : 'Min'} Temperature`,
    sensorType: 'Temperature',
    unit: 'ºC',
    data: extremeDailyData,
  };
};
